import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';
import { roleGuard } from './core/auth/role.guard';
import { ShellComponent } from './layout/shell/shell.component';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./features/auth/login/login.component').then((m) => m.LoginComponent)
  },
  {
    path: 'reset-password',
    loadComponent: () => import('./features/auth/reset-password/reset-password.component').then((m) => m.ResetPasswordComponent)
  },
  {
    path: '',
    component: ShellComponent,
    canActivate: [authGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      {
        path: 'dashboard',
        loadComponent: () => import('./features/dashboard/dashboard.component').then((m) => m.DashboardComponent)
      },
      {
        path: 'cambiar-password',
        loadComponent: () => import('./features/auth/change-password/change-password.component').then((m) => m.ChangePasswordComponent)
      },
      {
        path: 'admin/usuarios',
        canActivate: [roleGuard(['ADMIN'])],
        loadComponent: () => import('./features/admin/users/users.component').then((m) => m.UsersComponent)
      },
      {
        path: 'admin/auditoria',
        canActivate: [roleGuard(['ADMIN'])],
        loadComponent: () => import('./features/admin/audit/audit.component').then((m) => m.AuditComponent)
      },
      {
        path: 'admin/clientes-gestor',
        canActivate: [roleGuard(['ADMIN'])],
        loadComponent: () => import('./features/admin/gestor-access/gestor-access.component').then((m) => m.GestorAccessComponent)
      },
      {
        path: 'operativo/clientes',
        canActivate: [roleGuard(['ADMIN', 'OPERADOR'])],
        loadComponent: () => import('./features/operativo/client-query/client-query.component').then((m) => m.ClientQueryComponent)
      },
      {
        path: 'operativo/carga-bienes-arrendados',
        canActivate: [roleGuard(['ADMIN', 'OPERADOR'])],
        loadComponent: () => import('./features/operativo/bulk-rent-assets/bulk-rent-assets.component').then((m) => m.BulkRentAssetsComponent)
      },
      {
        path: 'operativo/estados-cuenta',
        canActivate: [roleGuard(['ADMIN', 'OPERADOR'])],
        loadComponent: () => import('./features/operativo/account-statements/account-statements.component').then((m) => m.AccountStatementsComponent)
      },
      {
        path: 'reportes/bienes-gestor',
        canActivate: [roleGuard(['ADMIN', 'OPERADOR'])],
        loadComponent: () => import('./features/reports/gestor-assets-report/gestor-assets-report.component').then((m) => m.GestorAssetsReportComponent)
      },
      {
        path: 'reportes/resumen-arrendatarios',
        canActivate: [roleGuard(['ADMIN', 'OPERADOR'])],
        loadComponent: () => import('./features/reports/tenant-summary-report/tenant-summary-report.component').then((m) => m.TenantSummaryReportComponent)
      },
      {
        path: 'reportes/verificacion-persona',
        canActivate: [roleGuard(['ADMIN', 'OPERADOR'])],
        loadComponent: () => import('./features/reports/person-verification-report/person-verification-report.component').then((m) => m.PersonVerificationReportComponent)
      },
      {
        path: 'cliente/perfil',
        canActivate: [roleGuard(['CLIENTE'])],
        loadComponent: () => import('./features/cliente/profile/client-profile.component').then((m) => m.ClientProfileComponent)
      },
      {
        path: 'cliente/productos',
        canActivate: [roleGuard(['CLIENTE'])],
        loadComponent: () => import('./features/cliente/products/client-products.component').then((m) => m.ClientProductsComponent)
      },
      {
        path: 'cliente/estado-cuenta',
        canActivate: [roleGuard(['CLIENTE'])],
        loadComponent: () => import('./features/cliente/account-state/account-state.component').then((m) => m.AccountStateComponent)
      },
      {
        path: 'cliente/movimientos',
        canActivate: [roleGuard(['CLIENTE'])],
        loadComponent: () => import('./features/cliente/movements/movements.component').then((m) => m.MovementsComponent)
      }
    ]
  },
  { path: '**', redirectTo: 'dashboard' }
];
